<template>
  <div class="multi-parts-copy-btn-wrapper">
    <button
      class="w-b-btn copy-btn"
      @click="isShowMultiPartsCopyPopup = true"
    > 他の列にコピー
    </button>
    <portal v-if="isShowMultiPartsCopyPopup" to="modal2">
      <modal @close="isShowMultiPartsCopyPopup = false">
        <template slot="title">{{ tabText() }}のコピー</template>
        <template slot="name">この列の{{ tabText() }}を他の列にコピーします<br>この操作は元に戻せません</template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="isShowMultiPartsCopyPopup = false" class="cancel normal-btn">キャンセル</button>
            <button type="button" @click="copyMultiPart" class="copy normal-btn">コピー</button>
          </div>
        </template>
      </modal>
    </portal>
  </div>
</template>

<script>
import Modal from '@/components/Util/Modal'

export default {
  props: [
    'sectionId',
    'partsContainerId',
    'parts',
    'tab',
    'tableId',
  ],
  components: {
    Modal,
  },
  data () {
    return {
      isShowMultiPartsCopyPopup: false,
    }
  },
  methods: {
    copyMultiPart () {
      this.$store.commit('copyMultiParts', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        tableId: this.tableId,
        selectedTab: this.tab
      })
      this.isShowMultiPartsCopyPopup = false
    },
    tabText () {
      switch (this.tab) {
        case 'Content':
          return 'テキスト'
        case 'Style':
          return 'スタイル'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.multi-parts-copy-btn-wrapper {
  position: relative;
  .copy-btn {
    width: 130px;
    position: absolute;
    top: 6px;
    left: 10px;
  }
}
.button-box {
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    border: solid 1px #c6c6c6;
    border-radius: 5px;
    &:hover {
      opacity: 0.8;
    }
    &.copy {
      margin-left: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
    }
  }
}
</style>
